import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { portalThemeResolver } from './core/resolvers/portal-theme.resolver';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./donor-portal/features/login/pages/donor-login.component').then(m => m.DonorLoginComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./donor-portal/features/login/pages/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: '',
    resolve: { _theme: portalThemeResolver },
    canActivate: [authGuard],
    loadComponent: () => import('./donor-portal/donor-portal.component').then(m => m.DonorPortalComponent),
    loadChildren: () => import('./donor-portal/donor-portal.routes').then(m => m.donorRoutes)
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/components/not-found/not-found-page.component').then(m => m.NotFoundPageComponent)
  }
];
